/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import * as b64$ from "../lib/base64.js";
import { ClosedEnum } from "../types/enums.js";

/**
 * GIF的背景颜色。留空则由后端服务决定默认值。
 */
export const GetImageMotouBgColor = {
  White: "white",
  Black: "black",
  Transparent: "transparent",
} as const;
/**
 * GIF的背景颜色。留空则由后端服务决定默认值。
 */
export type GetImageMotouBgColor = ClosedEnum<typeof GetImageMotouBgColor>;

export const GetImageMotouBgColor$zodSchema = z.enum([
  "white",
  "black",
  "transparent",
]).describe("GIF的背景颜色。留空则由后端服务决定默认值。");

export type GetImageMotouRequest = {
  qq: string;
  bg_color?: GetImageMotouBgColor | undefined;
};

export const GetImageMotouRequest$zodSchema: z.ZodType<GetImageMotouRequest> = z
  .object({
    bg_color: GetImageMotouBgColor$zodSchema.optional(),
    qq: z.string().describe("你想要摸头的对象的QQ号码。"),
  });

/**
 * 服务器内部错误。可能的原因包括：获取QQ头像失败，或在生成GIF过程中发生错误。
 */
export type GetImageMotouInternalServerErrorResponseBody = {
  error?: string | undefined;
};

export const GetImageMotouInternalServerErrorResponseBody$zodSchema: z.ZodType<
  GetImageMotouInternalServerErrorResponseBody
> = z.object({
  error: z.string().optional(),
}).describe(
  "服务器内部错误。可能的原因包括：获取QQ头像失败，或在生成GIF过程中发生错误。",
);

/**
 * 请求参数错误。必须提供有效的 'qq' 参数。
 */
export type GetImageMotouBadRequestResponseBody = {
  error?: string | undefined;
};

export const GetImageMotouBadRequestResponseBody$zodSchema: z.ZodType<
  GetImageMotouBadRequestResponseBody
> = z.object({
  error: z.string().optional(),
}).describe("请求参数错误。必须提供有效的 'qq' 参数。");

export type GetImageMotouResponse =
  | Uint8Array
  | string
  | GetImageMotouBadRequestResponseBody
  | GetImageMotouInternalServerErrorResponseBody;

export const GetImageMotouResponse$zodSchema: z.ZodType<GetImageMotouResponse> =
  z.union([
    z.string().describe("Base64-encoded binary content").transform(
      b64$.bytesFromBase64,
    ),
    z.lazy(() => GetImageMotouBadRequestResponseBody$zodSchema),
    z.lazy(() => GetImageMotouInternalServerErrorResponseBody$zodSchema),
  ]);
